import makeItemsReducer from './items'
import { isNull } from 'lodash'
import { clearItemsCache } from './items/utils'
import {
  GET_ITEMS_I_CAN_GET,
  SET_ITEM_NOT_OWNED_SUCCESS,
  I_WANT_SUCCESS,
  I_WANT_NOT_SUCCESS,
  OWNED_ITEM_UPDATED,
} from '../actions'

const handleItemsICanGet = (prevState, { type, payload }) => {
  // When no data in list don't care
  if (prevState && isNull(prevState.ids)) {
    return prevState
  }

  switch (type) {
    // Stupid implementation, this actions can lead a different non
    // deterministi items i can get
    case SET_ITEM_NOT_OWNED_SUCCESS:
    case OWNED_ITEM_UPDATED:
    case I_WANT_SUCCESS:
    case I_WANT_NOT_SUCCESS:
      return clearItemsCache(prevState)
    default:
      return prevState
  }
}

export default makeItemsReducer(GET_ITEMS_I_CAN_GET, {
  handleWanted: false,
  ownerDriven: true,
  extendReducers: [handleItemsICanGet],
})



// WEBPACK FOOTER //
// ./src/reducers/itemsICanGet.js